import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Phase 14a — Settings → Account *layout* route.
 *
 * The file-router treats `settings.account.tsx` as the parent of every
 * `settings.account.*` child (e.g. `settings.account.deleted.tsx`, and
 * the new `settings.account.index.tsx` carrying the live Account
 * surface). The parent must render `<Outlet />` so its children have
 * a slot to mount into; without it, navigating to a nested child
 * silently fell back to the parent component (same routing bug
 * pattern scenarios 11, 12, 18 fixed at the `sites.tsx` /
 * `sites.$siteId.tsx` / `sites.$siteId.panels.$panelId.tsx` layers).
 *
 * The parent is intentionally NOT auth-gated: the
 * `settings.account.deleted` child is the post-deletion landing,
 * which mounts after the user's Clerk session has been torn down and
 * must render fully anonymously. The auth gate lives on the index
 * route (`settings.account.index.tsx`) so the live Account surface
 * still requires `<SignedIn>`.
 */
export const Route = createFileRoute("/settings/account")({
  component: SettingsAccountLayout,
});

function SettingsAccountLayout() {
  return <Outlet />;
}
